<template lang='pug'>
  v-col(sm='12')
    v-row(no-gutters)
      v-col(style='padding: 0 20px')
        md-card
          md-card-header.md-card-header-icon.md-card-header-green
            .card-icon
              md-icon settings
            h4.title
              | {{ $t("fbChannel.connectionSettings.title") }}
          md-card-content
            form.form-horizontal(action method='post')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{$t("fbChannel.isEnabled")}}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success': canalFbChannels.config.isEnabled,\
                'text-danger': !canalFbChannels.config.isEnabled\
                }")
                  | {{
                  | canalFbChannels.config.isEnabled ? $t("commonWords.enabled"): $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalFbChannels.config.isEnabled')
              .md-layout-item.md-size-50
              .md-layout-item(style='margin: auto;')
                  md-field
                    label
                      | {{
                      | $t("fbChannel.connectionSettings.subitems.appId")
                      | }}
                    md-input(v-model='canalFbChannels.config.appId')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  md-field
                    label
                      | {{
                      | $t(
                      | "fbChannel.connectionSettings.subitems.secretKey"
                      | )
                      | }}
                    md-input(v-model='canalFbChannels.config.secretKey')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  md-field
                    label
                      | {{
                      | $t(
                      | "fbChannel.connectionSettings.subitems.accessToken"
                      | )
                      | }}
                    md-input(v-model='canalFbChannels.config.accessToken')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  md-field
                    label
                      | {{
                      | $t(
                      | "fbChannel.connectionSettings.subitems.appSecret"
                      | )
                      | }}
                    md-input(v-model='canalFbChannels.config.appSecret')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  md-field
                    label
                      | {{
                      | $t(
                      | "fbChannel.connectionSettings.subitems.pageId"
                      | )
                      | }}
                    md-input(v-model='canalFbChannels.config.pageId')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{$t("fbChannel.connectionSettings.subitems.isInactivityMessageEnabled")}}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success': canalFbChannels.config.isInactivityMessageEnabled,\
                'text-danger': !canalFbChannels.config.isInactivityMessageEnabled\
                }")
                  | {{
                  | canalFbChannels.config.isInactivityMessageEnabled ? $t("commonWords.enabled"): $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalFbChannels.config.isInactivityMessageEnabled')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  md-field
                    label
                      | {{
                      | $t(
                      | "fbChannel.connectionSettings.subitems.notEnabledMessage"
                      | )
                      | }}
                    md-input(v-model='canalFbChannels.config.notEnabledMessage')
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
  directives: { mask },
  props: {
    canalFbChannels: {
      type: Object,
      required: false
    }
  }
}
</script>

<style>
/* .v-input .v-label {
  line-height: 12px;
} */
/* .v-text-field .v-label {
  top: 0px !important;
  left: 0px !important;
} */
#attachment-autocomplete .v-icon.v-icon {
  font-size: 18px !important;
}
#attachment-autocomplete .theme--light.v-input, .theme--light.v-input textarea {
  color: #9c27b0 !important;
}
#attachment-autocomplete .v-chip.v-size--small {
  height: 20px !important;
}
#attachment-autocomplete .v-label {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #AAAAAA !important;
}
#attachment-autocomplete .theme--light.v-chip {
  background: #ff9800 !important;
}
</style>
